import { render, staticRenderFns } from "./commdityLeft.vue?vue&type=template&id=531c0680&scoped=true&"
import script from "./commdityLeft.vue?vue&type=script&lang=js&"
export * from "./commdityLeft.vue?vue&type=script&lang=js&"
import style0 from "./commdityLeft.vue?vue&type=style&index=0&id=531c0680&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531c0680",
  null
  
)

export default component.exports